import React, { Fragment, useMemo } from 'react'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import { Column, Divider, Text } from 'Components/UI'
import { AllFaqPagesData } from 'Data/types'

import FaqSectionAccordion from './Accordion'
import { Content } from './styles'

type Props = PaddingProps & {
  data: AllFaqPagesData
}

function FaqSection({ data, ...rest }: Props) {
  const sortedData = useMemo(() => {
    return data.allFaqPages.sort((a, b) => a.order - b.order)
  }, [data])

  return (
    <SectionWrapper {...rest}>
      <Content
        flexDirection={['column', 'column', 'column', 'column', 'row']}
        gap={11}
      >
        <Text as="h2" medium title title40>
          FAQ
        </Text>

        <Column
          fullWidth
          maxWidth={['unset', 'unset', 'unset', 'unset', '805px']}
          width="100%"
        >
          {sortedData.map((item, index) => (
            <Fragment key={item.id}>
              <FaqSectionAccordion
                content={item.content}
                key={item.id}
                title={item.title}
              />

              {index < sortedData.length - 1 && <Divider slight />}
            </Fragment>
          ))}
        </Column>
      </Content>
    </SectionWrapper>
  )
}

export default FaqSection
